import React from "react";
import { api } from "@/lib/config";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";

function Table({ headers, rows, testid }) {
  if (!rows.length) return <div data-testid={`${testid}-empty`} className="rounded-2xl border border-dashed border-black/10 p-10 text-center text-sm text-[color:var(--brand-woodDark)]">Nothing here yet.</div>;
  return (
    <div className="overflow-x-auto rounded-2xl border border-black/10 bg-white">
      <table className="w-full text-sm" data-testid={testid}>
        <thead className="bg-[color:var(--brand-stone)]/60 text-[color:var(--brand-woodDark)]">
          <tr>{headers.map((h) => <th key={h} className="text-left px-4 py-3 font-medium">{h}</th>)}</tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
    </div>
  );
}

export default function Submissions() {
  const [quotes, setQuotes] = React.useState([]);
  const [bookings, setBookings] = React.useState([]);
  const [contacts, setContacts] = React.useState([]);
  React.useEffect(() => {
    api.get("/admin/quotes").then((r) => setQuotes(r.data.items));
    api.get("/admin/bookings").then((r) => setBookings(r.data.items));
    api.get("/admin/contacts").then((r) => setContacts(r.data.items));
  }, []);
  return (
    <Tabs defaultValue="quotes">
      <TabsList className="bg-transparent border border-black/10 rounded-full p-1 h-auto">
        <TabsTrigger value="quotes" data-testid="sub-tab-quotes" className="rounded-full px-5 py-2 text-xs data-[state=active]:bg-[color:var(--brand-ink)] data-[state=active]:text-[color:var(--brand-cream)]">Quotes ({quotes.length})</TabsTrigger>
        <TabsTrigger value="bookings" data-testid="sub-tab-bookings" className="rounded-full px-5 py-2 text-xs data-[state=active]:bg-[color:var(--brand-ink)] data-[state=active]:text-[color:var(--brand-cream)]">Bookings ({bookings.length})</TabsTrigger>
        <TabsTrigger value="contacts" data-testid="sub-tab-contacts" className="rounded-full px-5 py-2 text-xs data-[state=active]:bg-[color:var(--brand-ink)] data-[state=active]:text-[color:var(--brand-cream)]">Contacts ({contacts.length})</TabsTrigger>
      </TabsList>

      <TabsContent value="quotes" className="mt-6">
        <Table
          testid="quotes-table"
          headers={["Name", "Project", "Email", "Phone", "Address", "Received"]}
          rows={quotes.map((q) => (
            <tr key={q.id} className="border-t border-black/5 hover:bg-black/2">
              <td className="px-4 py-3">{q.name}</td>
              <td className="px-4 py-3">{q.project_type}</td>
              <td className="px-4 py-3">{q.email}</td>
              <td className="px-4 py-3">{q.phone}</td>
              <td className="px-4 py-3">{q.address}</td>
              <td className="px-4 py-3">{new Date(q.created_at).toLocaleString()}</td>
            </tr>
          ))}
        />
      </TabsContent>
      <TabsContent value="bookings" className="mt-6">
        <Table
          testid="bookings-table"
          headers={["Name", "Service", "Date", "Time", "Email", "Phone", "Status"]}
          rows={bookings.map((b) => (
            <tr key={b.id} className="border-t border-black/5">
              <td className="px-4 py-3">{b.name}</td>
              <td className="px-4 py-3">{b.service}</td>
              <td className="px-4 py-3">{b.booking_date}</td>
              <td className="px-4 py-3">{b.time_slot}</td>
              <td className="px-4 py-3">{b.email}</td>
              <td className="px-4 py-3">{b.phone}</td>
              <td className="px-4 py-3">{b.status}</td>
            </tr>
          ))}
        />
      </TabsContent>
      <TabsContent value="contacts" className="mt-6">
        <Table
          testid="contacts-table"
          headers={["Name", "Email", "Phone", "Message", "Received"]}
          rows={contacts.map((c) => (
            <tr key={c.id} className="border-t border-black/5">
              <td className="px-4 py-3">{c.name}</td>
              <td className="px-4 py-3">{c.email}</td>
              <td className="px-4 py-3">{c.phone || "—"}</td>
              <td className="px-4 py-3 max-w-md truncate" title={c.message}>{c.message}</td>
              <td className="px-4 py-3">{new Date(c.created_at).toLocaleString()}</td>
            </tr>
          ))}
        />
      </TabsContent>
    </Tabs>
  );
}
